<template>
  <div class="not-found-404">
    <div class="title">
      Sorry, this content is not available yet
    </div>
    <div
      class="button"
      @click="back"
    >
      back
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  methods: {
    back() {
      window.history.back()
    },
  },
}
</script>

<style scoped>
.not-found-404 {
  text-align: center;
  background: #fff;
  padding: 2rem 0;
  margin: 1rem 0
}

.not-found-404 .title {
  padding: 2rem 1rem
}

.not-found-404 .button {
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid #4a5b7c;
  padding: 0.3rem 0.8rem;
  color: #4a5b7c;
  font-size: 15px;
  font-weight: 400;
  display: inline-block;
  cursor: pointer;
}
</style>
